<template>
  <svg
    width="14"
    height="17"
    viewBox="0 0 14 17"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.8 9.55078C8.90312 9.55078 8.47188 10.0508 7 10.0508C5.52812 10.0508 5.1 9.55078 4.2 9.55078C1.88125 9.55078 0 11.432 0 13.7508V14.5508C0 15.3789 0.671875 16.0508 1.5 16.0508H12.5C13.3281 16.0508 14 15.3789 14 14.5508V13.7508C14 11.432 12.1187 9.55078 9.8 9.55078ZM12.5 14.5508H1.5V13.7508C1.5 12.2633 2.7125 11.0508 4.2 11.0508C4.65625 11.0508 5.39687 11.5508 7 11.5508C8.61563 11.5508 9.34062 11.0508 9.8 11.0508C11.2875 11.0508 12.5 12.2633 12.5 13.7508V14.5508ZM7 9.05078C9.48438 9.05078 11.5 7.03516 11.5 4.55078C11.5 2.06641 9.48438 0.0507812 7 0.0507812C4.51562 0.0507812 2.5 2.06641 2.5 4.55078C2.5 7.03516 4.51562 9.05078 7 9.05078ZM7 1.55078C8.65312 1.55078 10 2.89766 10 4.55078C10 6.20391 8.65312 7.55078 7 7.55078C5.34688 7.55078 4 6.20391 4 4.55078C4 2.89766 5.34688 1.55078 7 1.55078Z"
    />
  </svg>
</template>
